export const menuItems = [ {
        id: 1,
        label: "Menü",
        isTitle: true,
        role:["*"],
        link: "/",
        subItems: [ 
        { 
            id: 100, 
            isTitle: true,
            link: "/userroles",
            hide: true,
            role: ["SuperAdmin","TlpAdmin"],
            subItems: [],
        }, 
        {
            id: 100, 
            isTitle: true,
            link: "/ouserbirimyetki",
            hide: true,
            role: ["SuperAdmin","TlpAdmin"],
            subItems: [],
        },
        {
            id: 100,  
            link:"/logout",
            role:["*"],
            hide: true,
            subItems: []
        }, 
        {
            id: 100,  
            link:"/login",
            role:["*"],
            hide: true,
            subItems: []
        }, 
        {
            id: 100,  
            link:"/talepdetail",
            role:["*"],
            hide: true,
            subItems: []
        }, 
        {
            id: 100,  
            link:"/sendverificationemail",
            role:["*"],
            hide: true,
            subItems: []
        }, 
        {
            id: 100,  
            link:"/tlptalepbildirim",
            role:["*"],
            hide: true,
            subItems: []
        }, 
    ]
    },  
    { 
        id: 400,
        label: "Talep Oluştur",
        icon: "bx bx-add-to-queue",
        link: "/tlptalepolustur",
        role:["SuperAdmin","TlpKullanici"],
        subItems: []
    },  
    
    { 
        id: 400,
        label: "Taleplerim",
        icon: "bx bx-list-ul",
        link: "/tlptaleplerim",
        role:["SuperAdmin","TlpKullanici"],
        subItems: []
    },  
    { 
        id: 400,
        label: "Birimin Talepleri",
        icon: "bx bx-menu-alt-right",
        link: "/birimtaleplerim",
        role:["SuperAdmin","TlpTalepBirim"],
        subItems: []
    },  

    { 
        id: 400,
        label: "Onay Bekleyen Talepler",
        icon: "bx bx-menu-alt-left",
        link: "/tlptalepamironay",
        role:["SuperAdmin","TlpOnayBekleyenler"],
        subItems: []
    },  


    
    { 
        id: 400,
        label: "Kullanıcılar",
        icon: "bx bx-user",
        link: "/opersonel",
        role:["SuperAdmin","TlpAdmin"],
        subItems: []
    }, 
    { 
        id: 400,
        label: "Birimler",
        icon: "bx bx-building-house",
        link: "/obirim",
        role:["SuperAdmin","TlpAdmin"],
        subItems: []
    }, 
    { 
        id: 400,
        label: "Talepler",
        icon: "bx bx-list-ul",
        link: "/tlptalep",
        role:["SuperAdmin","TlpAdmin","TlpMerkez"],
        subItems: []
    }, 
    { 
        id: 400,
        label: "Havuzdaki Talepler",
        icon: "bx bx-share",
        link: "/tlphavuz",
        role:["SuperAdmin","TlpAdmin","TlpMerkez"],
        subItems: []
    }, 
    { 
        id: 400,
        label: "Birim Talepleri",
        icon: "bx bx-shape-square",
        link: "/tlpbirimtalep",
        role:["SuperAdmin","TlpAdmin","TlpBirim"],
        subItems: []
    },  
    { 
        id: 400,
        label: "Bitiş Tarihi Yaklaşanlar",
        icon: "bx bx-calendar",
        link: "/bitistarihiyaklasan",
        role:["SuperAdmin","TlpAdmin"],
        subItems: []
    }, 
       
    { 
        id: 400,
        label: "Atanan Taleplerim",
        icon: "bx bx-user-voice",
        link: "/atanantalepler",
        role:["SuperAdmin","TlpAdmin","TlpAtananPersonel"],
        subItems: []
    }, 

    
    { 
        id: 400,
        label: "Plan & Rapor Veri Girişi",
        icon: "bx bx-calendar",
        link: "/tlpplanrapor",
        role:["TlpPlanRapor"],
        subItems: []
    }, 

    { 
        id: 400,
        label: "Plan & Rapor Takip",
        icon: "bx bx-calendar",
        link: "/tlpplanraportakip",
        role:["TlpPlanRaporTakip"],
        subItems: []
    }, 

    
    { 
        id: 400,
        label: "Profilim",
        icon: "bx bx-user-check",
        link: "/editprofil",
        role:["SuperAdmin","TlpAdmin","TlpBirim","TlpKullanici"],
        subItems: []
    },  

    { 
        id: 400,
        label: "Kurum Takip",
        icon: "bx bx-building-house",
        link: "/tlptaleptahsilat",
        role:["TlpTahsilat"],
        subItems: [
            {
                id: 410,
                label: "Sözleşme  Durumları",
                link: "/kurumsozlesme",
                role:["TlpTahsilat"],
                parentId: 300,
            },  
            {
                id: 410,
                label: "Sözleşmeler",
                link: "/osozlesme",
                role:["TlpTahsilat"],
                parentId: 300,
            },  
            {
                id: 410,
                label: "Kurum Belgeleri",
                link: "/obirimbelge",
                role:["TlpTahsilat"],
                parentId: 300,
            },

            {
                id: 410,
                label: "Kurum Görüşmeleri",
                link: "/okurumgorusme",
                role:["TlpTahsilat"],
                parentId: 300,
            },

            {
                id: 410,
                label: "Kurum Teklifleri",
                link: "/okurumteklif",
                role:["TlpTahsilat"],
                parentId: 300,
            },

            {
                id: 410,
                label: "Talep Tahsilat Durumları",
                link: "/tlptaleptahsilat",
                role:["TlpTahsilat"],
                parentId: 300,
            },
        ]
    },

    { 
        id: 400,
        label: "Raparlar",
        icon: "bx bx-file",
        link: "#",
        subItems: [ 
      
            {
                id: 410,
                label: "Personel Durum",
                link: "/personeldurum",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },   
            {
                id: 410,
                label: "Birim Durum",
                link: "/birimdurum",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },   
            {
                id: 410,
                label: "Talep Durum",
                link: "/talepdurum",
                role:["SuperAdmin","TlpAdmin", "TlpMerkez"],
                parentId: 300,
            }, 
            {
                id: 410,
                label: "Personelin Baktığı Talepler",
                link: "/personeltalep",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },     
       
       
        ]
    },
    
    { 
        id: 400,
        label: "Sistem Yönetimi",
        icon: "bx bx-cog",
        link: "#",
        subItems: [ 
      
            {
                id: 410,
                label: "Duyurular",
                link: "/oduyuru",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },   
      
            {
                id: 410,
                label: "Takvim",
                link: "/otakvim",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },     
            {
                id: 410,
                label: "Resmi Tatil",
                link: "/oresmitatil",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },
            {
                id: 411,
                label: "eCampus Personel Senkron",
                link: "/oecampussenkron",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },
            {
                id: 410,
                label: "E-posta Şablonları",
                link: "/tlpemailtemplate",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },   
            {
                id: 410,
                label: "Hazır Yanıtlar",
                link: "/tlphaziryanitlar",
                role:["SuperAdmin","TlpAdmin"],
                parentId: 300,
            },   
        ]
    }

  
   
    
];